// extracted by mini-css-extract-plugin
export var fixed = "container-module--fixed--5618a";
export var full = "container-module--full--a7312";
export var header = "container-module--header--a739e";
export var withSidebar = "container-module--withSidebar--ee015";